module.exports = __webpack_public_path__ + "img/reseaux-follow.9c87f803.png";